import React, { useEffect } from 'react'
import PageTitle from '../../../components/partials/PageTitle'
import BARCHART from '../../../assets/images/barchart.png'
import PIECHART from '../../../assets/images/piechart.png'
import LINEGRAPH from '../../../assets/images/linegraph.jpg'
import {BsCashStack} from 'react-icons/bs'
import {TbStack2} from 'react-icons/tb'
import {IoCashOutline} from 'react-icons/io5'
import {GiReceiveMoney} from 'react-icons/gi'
import {HiOutlineDocumentDuplicate, HiOutlineUsers} from 'react-icons/hi2'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { resetCustomerOverviewData } from '../../../redux/slice/report/reportSlice'

const reports = [
  {name: 'Customer Report',icon: <HiOutlineUsers size={20} />, link: '/admin/reports/customer-overview', permission: 'customer overview report',},
  {name: 'General Policy Report',icon: <HiOutlineDocumentDuplicate size={22}/>, link: '/admin/reports/policy-report', permission: 'customer report module',},
  {name: 'Savings Policy Report',icon: <HiOutlineDocumentDuplicate size={22}/>, link: '/admin/reports/savings-policy-report', permission: 'customer report module',},
  // {name: 'Premium Report',icon: <BsCashStack size={22}/>, link: '/admin/reports/customer-payment', permission: 'customer premuin payment report',},
  // {name: 'Claims Report',icon: <GiReceiveMoney size={22}/>, link: '/admin/reports/claim-report', permission: 'customer report module',},
  {name: 'Financial Report',icon: <IoCashOutline size={22} />, link: '/admin/reports/financial-report', permission: 'customer report module',},
  {name: 'Agent Report',icon: <IoCashOutline size={22} />, link: '/admin/reports/agent-report', permission: 'customer report module',},
  {name: 'Audit Report',icon: <TbStack2 size={22} />, link: '/admin/reports/audit-report', permission: 'customer report module',},
]
const ReportDash = () => {
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const dispatch = useDispatch()

  // const navigate = useNavigate();
  // breadcrumb
  const breadcrumb = {
    from: {
      title: "Reports",
      link: "/admin/reports",
    },
    current: {
      title: "Report Dashboard",
      link: null,
    },
  };
  const filteredReports = reports.filter((item) => {
    return user_permissions?.some((permission) => permission.name === item.permission);
  });
  useEffect(() => {
    dispatch(resetCustomerOverviewData())
  }, [dispatch])

  // useEffect(() => {
  //   if (!user_permissions?.some(permission => permission.name === 'customer report module')) {
  //     navigate('/admin/dashboard')
  //   }
  // }, [navigate, user_permissions])
  return (
    <div>
      {/* page title */}
      <PageTitle title='Report Dashboard' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row card p-1' style={{ margin: "auto 1px" }}>
        {/* <div>
          <h4>Data Visualization</h4>
          <div className='row mb-5'>
            <div className="col-md-4">
              <img src={BARCHART} alt="barchart" className='w-50' />
            </div>
            <div className="col-md-4">
              <img src={PIECHART} alt="piechart" className='w-50' />
            </div>
            <div className="col-md-4">
              <img src={LINEGRAPH} alt="linegraph" className='w-50' />
            </div>
          </div>
        </div> */}
        <div className=" position-relative d-flex align-items-center gap-3 overflow-scroll scrollbar-hide p-1">
          {filteredReports?.map((item, i) => (
            <Link to={item?.link} className='w-100 bg-white shadow-sm gap-2 d-flex align-items-center rounded-pill p-2 cursor-pointer' key={i}>
              <div className='bg-primary d-flex align-items-center justify-content-center rounded-circle' style={{width: '40px', height:'40px'}}>
                <span className='text-white'>{item?.icon}</span>
              </div>
              <div>
                <p className='text-nowrap m-0'>{item?.name}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ReportDash